import HttpResponse from "../../../../../utils/http/http.response";

export enum ContractsTaxiDriverDetailsResponseItemModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export type ContractsTaxiDriverDetailsResponseItem = {
  validSince: Date;
  validTo: Date;
  disabled: boolean;
  model: ContractsTaxiDriverDetailsResponseItemModel;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
  description: string | null;
};

type ContractsTaxiDriverDetailsResponse =
  HttpResponse<ContractsTaxiDriverDetailsResponseItem>;

export default ContractsTaxiDriverDetailsResponse;
